var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{ref:"CPBtn",staticClass:"combine-pay-btn",style:(_vm.updateStyle),attrs:{"id":"CPBtn","type":"button"}},[_c('icon-wallet',{staticClass:"icon-wallet",attrs:{"color":_vm.color}}),_c('span',{staticClass:"btn-txt",style:({color: _vm.color})},[_vm._v("合并支付")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }